import { Component, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef, Inject, Renderer2, ViewChild, ElementRef, ViewChildren, QueryList, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { DOCUMENT } from '@angular/common';
import { CustomizerService } from '../services/customizer.service';
import { UntypedFormControl } from '@angular/forms';
import { LISTITEMS } from '../data/template-search';
import { Router } from '@angular/router';
import { ROUTES } from '../vertical-menu/vertical-menu-routes.config';
import { AuthService } from 'app/service/auth/auth.service';
import { tblUserMaster } from 'app/models/user/tblusermaster';
import { MyspinnerService } from 'app/service/util-service/myspinner.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'app/service/user.service';
import { UserApplicationService } from 'app/service/userapplication.service';
import { SessionHelperService } from 'app/service/util-service/sessionhelper.service';
import { routeIcons } from 'app/pages/content-pages/login/routesicon';
import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';
import { tblRoleWiseUserPermission } from 'app/models/config/tblrolewiseuserpermission';
import { ensureFitterflyAdditivesMenuItem, sortMasterDataNavModules, sortMasterDataSubmenu } from 'app/helper/menu-order.helper';
import { ConfigService as CustomeConfigService } from 'app/service/config.service';
import { Role } from 'app/service/enum/role';
import { GlobalHelper } from 'app/helper/globalhelper';
import { EnhancedMenuService } from 'app/service/enhanced-menu.service';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = "en";
  selectedLanguageText = "English";
  selectedLanguageFlag = "./assets/img/flags/us.png";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = "";
  transparentBGClass = "";
  hideSidebar: boolean = true;
  public isCollapsed = true;
  layoutSub: Subscription;
  configSub: Subscription;
  @ViewChild('search') searchElement: ElementRef;
  @ViewChildren('searchResults') searchResults: QueryList<any>;
  @ViewChild('roleSwitcher') roleSwitcherRef: ElementRef;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  listItems = [];
  control = new UntypedFormControl();

  public config: any = {};
  public pageTitleName: string;
  public logginedUser: tblUserMaster;
  public avatarSrc = 'assets/img/images.png';
  public roleEnum = Role;
  public isActivatedUser: boolean = true;
  public isRoleDropdownOpen: boolean = false;
  private userUpdateSub: Subscription;

  constructor(public translate: TranslateService,
    private layoutService: LayoutService,
    private router: Router,
    private configService: ConfigService,
    private customeConfigService: CustomeConfigService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private mySpinner: MyspinnerService,
    public toastr: ToastrService,
    public userService: UserService,
    private userApplicationService: UserApplicationService,
    private enhancedMenuService: EnhancedMenuService,
  ) {

    // const browserLang: string = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : "en");
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;

    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });

  }

  ngOnInit() {
    this.listItems = LISTITEMS;

    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
    this.logginedUser = this.authService.getLoggedInUser();
    this.avatarSrc = this.resolveAvatarSrc(this.logginedUser?.profileImage);
    if (this.logginedUser && this.logginedUser.roleIds) {
      this.isActivatedUser = this.logginedUser.roleIds.length > 1;
    }

    this.userUpdateSub = this.authService.userUpdateSubject$.subscribe(user => {
      if (user) {
        this.logginedUser = user;
        this.avatarSrc = this.resolveAvatarSrc(user?.profileImage);
        this.cdr.markForCheck();
      }
    });
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
    // this.isActivatedUser = JSON.parse(SessionHelperService.readSessionVariableOnlyKeyEncryption("vroutes")).length > 1;

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
    if (this.userUpdateSub) {
      this.userUpdateSub.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as Node;
    if (this.isRoleDropdownOpen && this.roleSwitcherRef?.nativeElement && !this.roleSwitcherRef.nativeElement.contains(target)) {
      this.isRoleDropdownOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.isRoleDropdownOpen = false;
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === "Light") {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add('first-active-item');
    }

    if (event.target.value === "") {
      this.seachTextEmpty.emit(true);
    }
    else {
      this.seachTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove('first-active-item');
    }
  }

  onEscEvent() {
    this.control.setValue("");
    this.searchOpenClass = '';
    this.seachTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      let url = this.searchResults.first.url;
      if (url && url != '') {
        this.control.setValue("");
        this.searchOpenClass = '';
        this.router.navigate([url]);
        this.seachTextEmpty.emit(true);
      }
    }
  }

  redirectTo(value) {
    this.router.navigate([value]);
    this.seachTextEmpty.emit(true);
  }


  ChangeLanguage(language: string) {
    this.translate.use(language);

    if (language === 'en') {
      this.selectedLanguageText = "English";
      this.selectedLanguageFlag = "./assets/img/flags/us.png";
    }
    else if (language === 'es') {
      this.selectedLanguageText = "Spanish";
      this.selectedLanguageFlag = "./assets/img/flags/es.png";
    }
    else if (language === 'pt') {
      this.selectedLanguageText = "Portuguese";
      this.selectedLanguageFlag = "./assets/img/flags/pt.png";
    }
    else if (language === 'de') {
      this.selectedLanguageText = "German";
      this.selectedLanguageFlag = "./assets/img/flags/de.png";
    }
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleSearchOpenClass(display) {
    this.control.setValue("");
    if (display) {
      this.searchOpenClass = 'open';
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 0);
    }
    else {
      this.searchOpenClass = '';
    }
    this.seachTextEmpty.emit(true);
  }

  toggleNotificationSidebar() {
    this.layoutService.toggleNotificationSidebar(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

  public getpageTitleName(): string {
    const routes = this.authService.getVerticalRoutes();
    // router.url includes query params; do not show them in header/breadcrumb titles
    const currentUrl = (this.router.url || '').split('?')[0];

    // Recursive function to find a route by full or partial URL match
    function findBestMatchingRoute(routes: any[], url: string): any {
      let bestMatch = null;

      for (let route of routes) {
        if (url === route.path) return route;

        if (url.startsWith(route.path) && (!bestMatch || route.path.length > bestMatch.path.length)) {
          bestMatch = route;
        }

        if (route.submenu && route.submenu.length > 0) {
          const found = findBestMatchingRoute(route.submenu, url);
          if (found) {
            if (url === found.path) return found; // exact match in submenu
            if (!bestMatch || found.path.length > bestMatch.path.length) {
              bestMatch = found;
            }
          }
        }
      }

      return bestMatch;
    }

    if (routes && routes.length > 0) {
      const selectedMenu = findBestMatchingRoute(routes, currentUrl);

      if (selectedMenu && selectedMenu.title) {
        return selectedMenu.title === "Recipes" ? "Recipe Master" : selectedMenu.title;
      }
    }

    // Fallback: Format current URL into a title
    const fallbackTitle = currentUrl
      .split('/')
      .filter(Boolean)
      .pop()
      ?.replace(/-/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase()) || "Not Found";

    return fallbackTitle;
  }

  public logout() {
    void Swal.fire({
      title: 'Logout',
      text: 'Are you sure you want to logout?',
      icon: 'question',
      iconColor: '#7c3aed',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      buttonsStyling: false,
      customClass: {
        popup: 'navbar-logout-swal',
        title: 'navbar-logout-swal__title',
        actions: 'navbar-logout-swal__actions',
        confirmButton: 'navbar-logout-swal__confirm',
        cancelButton: 'navbar-logout-swal__cancel',
      },
      reverseButtons: true,
      allowOutsideClick: false,
      didOpen: () => {
        const popup = Swal.getPopup();
        popup?.setAttribute('data-logout-dialog', 'true');
        const icon = popup?.querySelector('.swal2-icon') as HTMLElement | null;
        const html = popup?.querySelector('.swal2-html-container') as HTMLElement | null;
        const actions = popup?.querySelector('.swal2-actions') as HTMLElement | null;
        const confirmButton = popup?.querySelector('.swal2-confirm') as HTMLButtonElement | null;
        const cancelButton = popup?.querySelector('.swal2-cancel') as HTMLButtonElement | null;

        if (icon) {
          icon.classList.add('navbar-logout-swal__icon');
        }

        if (html) {
          html.classList.add('navbar-logout-swal__text');
        }

        if (actions) {
          actions.style.display = 'flex';
          actions.style.alignItems = 'center';
          actions.style.justifyContent = 'center';
          actions.style.gap = '14px';
          actions.style.marginTop = '20px';
        }

        if (confirmButton) {
          confirmButton.style.minWidth = '104px';
          confirmButton.style.height = '44px';
          confirmButton.style.padding = '0 18px';
          confirmButton.style.borderRadius = '12px';
          confirmButton.style.border = '0';
          confirmButton.style.color = '#ffffff';
          confirmButton.style.fontWeight = '700';
          confirmButton.style.background = 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)';
          confirmButton.style.boxShadow = '0 12px 24px rgba(124, 58, 237, 0.28)';
          confirmButton.style.fontSize = '14px';
        }

        if (cancelButton) {
          cancelButton.style.minWidth = '104px';
          cancelButton.style.height = '44px';
          cancelButton.style.padding = '0 18px';
          cancelButton.style.borderRadius = '12px';
          cancelButton.style.border = '1px solid #d8c9ff';
          cancelButton.style.color = '#4c1d95';
          cancelButton.style.background = '#ffffff';
          cancelButton.style.fontWeight = '700';
          cancelButton.style.fontSize = '14px';
          cancelButton.style.boxShadow = 'none';
        }
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout();
      }
    });
  }

  public onAvatarError(): void {
    if (this.avatarSrc !== 'assets/img/images.png') {
      this.avatarSrc = 'assets/img/images.png';
    }
  }

  public toggleRoleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.isRoleDropdownOpen = !this.isRoleDropdownOpen;
  }

  public selectRole(roleId: number) {
    this.isRoleDropdownOpen = false;
    if (roleId === this.getCurrentRoleId()) {
      return;
    }
    void this.onSubRoleChange(roleId);
  }

  public getCurrentRoleId(): number | null {
    return this.logginedUser?.currentRoleId ?? this.logginedUser?.roleIds?.[0] ?? null;
  }

  public getCurrentRoleLabel(): string {
    const roleId = this.getCurrentRoleId();
    switch (roleId) {
      case Role.SuperAdmin:
        return 'Super Admin';
      case Role.Assigner:
        return 'Assigner';
      case Role.Approver:
        return 'Approver';
      case Role.Checker:
        return 'Checker';
      case Role.Maker:
        return 'Maker';
      default:
        return 'Select Role';
    }
  }

  private resolveAvatarSrc(rawUrl?: string | null): string {
    const url = (rawUrl || '').trim();
    if (!url) return 'assets/img/images.png';
    if (/^(data:|https?:\/\/|\/\/)/i.test(url)) return url;
    const normalized = url.replace(/^\/+/, '');
    return `${environment.baseUrl.replace(/\/+$/, '')}/${normalized}`;
  }

  public getRoleIconClass(roleId: number | null): string {
    switch (roleId) {
      case Role.SuperAdmin:
        return 'ft-shield';
      case Role.Assigner:
        return 'ft-user';
      case Role.Approver:
        return 'ft-check-circle';
      case Role.Checker:
        return 'ft-search';
      case Role.Maker:
        return 'ft-edit-2';
      default:
        return 'ft-user';
    }
  }

  public getRoleToneClass(roleId: number | null): string {
    switch (roleId) {
      case Role.SuperAdmin:
        return 'role-icon--purple';
      case Role.Assigner:
        return 'role-icon--blue';
      case Role.Approver:
        return 'role-icon--green';
      case Role.Checker:
        return 'role-icon--orange';
      case Role.Maker:
        return 'role-icon--cyan';
      default:
        return 'role-icon--purple';
    }
  }

  public async onSubRoleChange(selectedSubRole: number) {
    try {
      this.mySpinner.showSpinner();
      let res = await this.userService.updateCurrentRoleId(this.logginedUser.id, selectedSubRole);
      if (res)
        if (res.status == 0) {
          this.toastr.success(res.message);
          let tokenData = SessionHelperService.readSessionVariable("userToken");
          if (tokenData) {
            let authToken = JSON.parse(tokenData);
            authToken.currentRoleId = selectedSubRole;
            SessionHelperService.removeSessionVariable("userToken");
            SessionHelperService.saveSessionVariable("userToken", JSON.stringify(authToken));
          }

          let loginUser = await this.userService.getUserById(this.logginedUser.id);
          if (loginUser && loginUser.status == 0) {
            SessionHelperService.removeSessionVariable("loginUser");
            SessionHelperService.saveSessionVariable('loginUser', JSON.stringify(loginUser.response));
          }

          // Clear user-specific cache to ensure fresh data for new role
          this.enhancedMenuService.clearUserCache(this.logginedUser.id);
          
          // Notify other components about role change
          this.authService.notifyRoleChange(selectedSubRole);
          
          this.router.navigate(['/dashboard/dashboard']);
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
        else
          this.toastr.warning(res.message);
      this.mySpinner.hideSpinner();
    } catch (error) {
      this.mySpinner.hideSpinner();
      this.toastr.error((error && error.statusText ? error.statusText : (error && error.message ? error.message : "")));
    }
  }

  //#region  New NavTree Setup


  private async setupUserNavigation(userId: string) {
    try {
      SessionHelperService.removeSessionVariable("navTree");
      SessionHelperService.removeSessionVariable("userPermissions");
      SessionHelperService.removeSessionVariable("currentRoleId");
      SessionHelperService.removeSessionVariable("privileges");

      const userPermissions = await this.customeConfigService.getRoleWiseUserPermissionByUserId(userId);
      if (userPermissions.response && userPermissions.response.length > 0)
        SessionHelperService.saveSessionVariableOnlyKeyEncryption('userPermissions', JSON.stringify(userPermissions.response
          .map((p: any) => ({ ...p, navTreeId: p.navTreeId ?? 0 }))));

      const loginUserRes = await this.userApplicationService.getUserApplicationById(userId);
      const currentUser = loginUserRes?.response;
      const currentRoleId = currentUser?.currentRoleId ?? 0;

      if (currentRoleId) {
        SessionHelperService.saveSessionVariableOnlyKeyEncryption('currentRoleId', currentRoleId.toString());
      }
      let roleId = currentRoleId > 0 ? currentRoleId : (currentUser.roleIds && currentUser.roleIds.length > 0 ? currentUser?.roleIds[0] : 1);
      const navTreeRes = await this.customeConfigService.getUserPermissionWiseNavTree(userId, roleId);
      if (navTreeRes.response && navTreeRes.response.length > 0)
        SessionHelperService.saveSessionVariableOnlyKeyEncryption('navTree', JSON.stringify(navTreeRes.response));


      const filteredPermissions = userPermissions.response?.filter((perm: any) => perm.roleId === currentRoleId) ?? [];

      let structuredRoutes = this.groupByParentId(navTreeRes.response ?? [], filteredPermissions);
      console.log('Structured routes:', structuredRoutes.length);
      
      let vroutes: RouteInfo[] = [];
      if (structuredRoutes && structuredRoutes.length > 0) {
        SessionHelperService.saveSessionVariableOnlyKeyEncryption('privileges', JSON.stringify(structuredRoutes));
        vroutes = this.toVerticalRoute(structuredRoutes);
        console.log('Generated vertical routes:', vroutes.length);
      }

      if (vroutes.length > 0) {
        console.log('Setting dynamic routes:', vroutes.length, 'items');
        this.authService.setVeticalRoutes(this.assignIconsToRoutes(vroutes));
        return true;
      }
      else {
        console.log('No dynamic routes generated, setting default Dashboard only');
        const dash: RouteInfo = {
          path: "/dashboard/dashboard",
          name: "dashboard",
          title: "Dashboard",
          icon: "assets/img/dashbord/icon/dashbord.png",
          class: "",
          isExternalLink: false,
          displayName: "Dashboard",
          sortOrder: 1,
          submenu: [],
        };
        this.authService.setVeticalRoutes([dash]);
        return true;
      }

    } catch (error) {
      this.toastr.error(" " + (error && error.statusText ? error.statusText : (error && error.message ? error.message : "")));
    }
  }

  private groupByParentId(modules, userPriv: tblRoleWiseUserPermission[]) {
    if (modules && modules.length > 0) {
      console.log('Processing modules:', modules.length);
      console.log('User permissions:', userPriv?.length || 0);
      
      modules.forEach((m) => {
        const usrpv = userPriv?.find((p) => p.navTreeId === m.id && p.isAccess && p.isActive);

        // Set isAccess flag on the module (can be used like isView)
        m.isAccess = !!usrpv;
        
        console.log(`Module: ${m.moduleName}, ID: ${m.id}, isAccess: ${m.isAccess}`);

        // Optional: Assign route name
        m.route = this.genStringRoute(m.moduleName);
      });

      const moduleMap = new Map();
      modules.forEach((module) => {
        module.submodules = [];
        moduleMap.set(module.id, module);
      });

      const groupedList = [];
      modules.forEach((module) => {
        const parentId = module.parentId;
        if (parentId === 0 || !parentId) {
          groupedList.push(module);
        } else {
          const parentModule = moduleMap.get(parentId);
          if (parentModule) {
            parentModule.submodules.push(module);
          }
        }
      });

      sortMasterDataNavModules(groupedList);

      return groupedList;
    }
    return [];
  }

  private genStringRoute(inputString: string): string {
    // Map specific module names to their expected route names
    const routeMapping: { [key: string]: string } = {
      'UserManagement': 'user',
      'UserApplications': 'userapplication',
      'MasterData': 'master',
      'Configuration': 'configuration',
      'Reports': 'reports',
      'Settings': 'settings',
      'Dashboard': 'dashboard',
      'Recipes': 'recipe',
      'AddRecipe': 'addrecipe',
      'Billing': 'billing',
      'FinishProduct': 'finishproduct',
      'RecipeCategory': 'recipe-category'
    };

    // Check if we have a specific mapping
    if (routeMapping[inputString]) {
      return routeMapping[inputString];
    }

    // Fallback to the original logic
    return inputString.replace(/[^a-zA-Z]/g, '').toLowerCase();
  }

  private toVerticalRoute(modules: any[], parentPath: string = ''): RouteInfo[] {
    console.log('toVerticalRoute - Input modules:', modules.length);
    
    const filteredModules = modules.filter(module => module.isAccess && module.isActive);
    console.log('toVerticalRoute - Filtered modules:', filteredModules.length);
    
    const routes = filteredModules.map(module => {
      console.log(`Creating route for: ${module.moduleName}, isAccess: ${module.isAccess}, isActive: ${module.isActive}`);
      
      return {
        path: `${parentPath}/${module.route}`,
        name: module.route,
        title: module.moduleName,
        icon: module.parentId ? 'ft-arrow-right submenu-icon' : 'ft-home',
        class: module.submodules.some(i => i.isActive) ? 'has-sub' : '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        displayName: module.displayName,
        sortOrder: module.sortOrder,
        submenu: this.toVerticalRoute(module.submodules, `${parentPath}/${module.route}`)
      };
    });
    
    console.log('toVerticalRoute - Generated routes:', routes.length);
    return routes;
  }

  private assignIconsToRoutes(routes: RouteInfo[]): RouteInfo[] {
    let orderedRoutes: RouteInfo[] = [];

    // Add Dashboard first
    const dash: RouteInfo = {
      path: "/dashboard/dashboard",
      name: "dashboard",
      title: "Dashboard",
      icon: "assets/img/dashbord/icon/dashbord.png",
      class: "",
      isExternalLink: false,
      displayName: "Dashboard",
      sortOrder: 1,
      submenu: [],
    };
    orderedRoutes.push(dash);

    // Process all routes and assign icons based on module name matching
    routes.forEach((route) => {
      // Find matching icon based on route name or title
      const matchingIcon = routeIcons.find((icon) => {
        const routeName = route.name?.toLowerCase();
        const routeTitle = route.title?.toLowerCase();
        const iconRoute = icon.route.toLowerCase();
        
        // Check for exact matches or partial matches
        return routeName === iconRoute || 
               routeTitle === iconRoute ||
               routeName?.includes(iconRoute) ||
               routeTitle?.includes(iconRoute) ||
               iconRoute.includes(routeName) ||
               iconRoute.includes(routeTitle);
      });

      if (matchingIcon) {
        route.icon = matchingIcon.icon;
      } else {
        // Default icon if no match found - use different icons based on route name
        const routeName = route.name?.toLowerCase() || '';
        if (routeName.includes('user')) {
          route.icon = "assets/img/dashbord/icon/rework.png";
        } else if (routeName.includes('recipe')) {
          route.icon = "assets/img/dashbord/icon/recipe.png";
        } else if (routeName.includes('billing')) {
          route.icon = "assets/img/dashbord/icon/billing.png";
        } else if (routeName.includes('master') || routeName.includes('config') || routeName.includes('report') || routeName.includes('setting')) {
          route.icon = "assets/img/dashbord/icon/knowledge.png";
        } else {
          route.icon = "assets/img/dashbord/icon/rework.png";
        }
      }

      orderedRoutes.push(route);
    });

    orderedRoutes.forEach((route) => {
      const title = (route.displayName || route.title || '').toString();
      if (title.toLowerCase() === 'master data' || route.name === 'master') {
        route.submenu = sortMasterDataSubmenu(title, route.submenu || []);
      }
    });

    // Sort by sortOrder if available
    orderedRoutes.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));

    return orderedRoutes;
  }
  //#endregion
}
